import { DateTime, DateTimeService, useLanguageCode, useRelativeDateTime, useTimezone } from '@mews/framework';

export const RelativeDateTime = ({ dateTime }: { dateTime: DateTime }) => {
    const locale = useLanguageCode();
    const timezone = useTimezone();
    const formatted = useRelativeDateTime({ dateTime, locale, timezone });
    return <>{formatted}</>;
};

export const RelativeDateTimeUtc = ({ utcString }: { utcString: string }) => {
    const timezone = useTimezone();
    return <RelativeDateTime dateTime={DateTimeService.fromUtcString(utcString, timezone)} />;
};
